import { Collection } from 'modules/core/lib/mobx-rest'

import BlockedPeriod from 'modules/timeoff/store/models/BlockedPeriods/BlockedPeriod'

export class BlockedPeriods extends Collection<BlockedPeriod> {
  get cacheKey(): string {
    return 'blockedPeriods'
  }

  model() {
    return BlockedPeriod
  }
}

const singleton: BlockedPeriods = new BlockedPeriods()

export default singleton
